import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Introduction from '../components/Introduction';
import Services from '../components/Services';
import GeneralInfo from '../components/GeneralInfo';
import Reviews from '../components/Reviews';
import DemoLessonForm from '../components/DemoLessonForm';
import Reveal from '../components/Reveal';

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Support deep-linking to sections like #demo-lesson
    const hash = location.hash?.replace('#', '');
    if (!hash) return;
    // Delay to ensure content (and Reveal animations) have mounted
    const id = window.setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);
    return () => window.clearTimeout(id);
  }, [location.hash]);

  return (
    <>
      <Hero />
      <Reveal as="section" delayMs={80}>
        <Introduction />
      </Reveal>
      <Reveal as="section" delayMs={120}>
        <Services />
      </Reveal>
      <Reveal as="section" delayMs={160}>
        <GeneralInfo />
      </Reveal>
      <Reveal as="section" delayMs={200}>
        <Reviews />
      </Reveal>
      <Reveal as="section" delayMs={240}>
        <DemoLessonForm />
      </Reveal>
    </>
  );
};

export default Home;